import { render, staticRenderFns } from "./addShareReading.vue?vue&type=template&id=185b4fe2"
import script from "./addShareReading.vue?vue&type=script&lang=js"
export * from "./addShareReading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports